export default "__VITE_ASSET__CD7f1T8K__"